/** @format */

import React from 'react';
import intl from 'react-intl-universal';
//import PercentageCircle from 'src/ui/library/PercentageCircle';
import QuestionnaireTopHeader from './QuestionnaireTopHeader';
import { QUESTIONNAIRE_PAGE_URL } from 'src/constants/constants.js';
import urlParamsMapper from 'src/helpers/urlParamsMapper.js';
import ContentParser from 'src/ui/library/ContentParser';
import { ActionsBarContainer } from 'src/ui/features/Questionnaire/containers';
import flattenSubMenu from 'src/helpers/flattenSubMenu.js';
import ServiceSpinner from 'src/ui/library/ServiceSpinner';
import iconTransform from 'src/helpers/iconTransform';
import getCaseDetailPath from 'src/ui/features/Questionnaire/helpers/getCaseDetailPath';
// import UserGuide from "src/ui/features/UserGuide";
import Link from '@mui/material/Link';
import Grid from 'src/ui/library/Grid/Grid';
import SaveIcon from '@mui/icons-material/Save';

//const goldColor = '#f5a623';
//const greenColor = '#2eb757';

const parsePercentString = value => parseInt(value, 10);
let saveQuestionnaireFn = () => {};
let forceDisableSubmitBtnFn = () => {};

export const QuestionnairePagePres = ({
  sectionProgress,
  introData,
  pageData,
  push,
  isMobile,
  goBack,
  match,
  setFormValues,
  formValues,
  setSaveHandler,
  onSave,
  savingPage,
  setShowErrors,
  isShowingErrors,
  isMenuClicked,
  resetMenuButtonClicked,
  history,
  showUserGuide,
  reloadPage,
  toggleReloadPage,
  displaySavePOPUP,
  elementUD,
  allowedSpecialChars,
  allowedValidationMessageSpecialChars,
  additionalCharRestict,
  location,
}) => {
  // if (!introData || !pageData || savingPage) {
  if (!pageData || savingPage) {
    return <ServiceSpinner />;
  }
  const overallProgress = parsePercentString(introData.overallProgress);
  let { sectionName, pageId } = match.params;
  sectionName = (pageData.sectionNameOldNew && JSON.parse(pageData.sectionNameOldNew)[sectionName]) || sectionName;
  match.params.sectionName = sectionName;
  // const { sectionProgress } = introData.menus.filter(m => m.menuName === sectionName)[0] || {};

  const { menuName, subMenu } = pageData.menus.filter(m => m.menuName === sectionName)[0] || {};
  let pageObj = {};
  if (subMenu && subMenu.length) {
    const flattenedSubMenu = flattenSubMenu(subMenu);
    pageObj = flattenedSubMenu.filter(m => m.pageId === Number(pageId))[0] || {};
  }
  const { align, icon } = pageObj;
  const sectionProgressPercent = sectionProgress && sectionProgress[sectionName] ? sectionProgress[sectionName].progress : 0;

  const redirectPage = () => {
    push(getCaseDetailPath(location));
  };
  //// console.log(JSON.stringify(formValues))
  return (
    <div className="questionnaire-page-body">
      <QuestionnaireTopHeader
        title={pageObj.menuName}
        onClose={() => (elementUD ? displaySavePOPUP(true) : onSave(() => redirectPage()))}
        overallProgress={overallProgress}
        isDataPage
      />
      <div className="questionnaire-page-title-container">
        <Grid container className="header-title-container">
          <Grid item xs={12}>
            <div className="data-page-header">
              {icon && <span className="data-page-icon">{iconTransform(icon, !isMobile && { fontSize: 30 })}</span>}
              <span className="data-page-title">
                <h2 className="title-header">{pageObj.menuName}</h2>
              </span>
              <span className="data-page-save">
                <Link
                  component="button"
                  underline="hover"
                  className="textLink-button"
                  onClick={() => onSave(push(urlParamsMapper(QUESTIONNAIRE_PAGE_URL, match.params)))}>
                  <SaveIcon sx={{ mr: 0.5, verticalAlign: 'text-top', fontSize: 14 }} />
                  {intl.get('questionnaire.actionBar.save')}
                </Link>
              </span>
            </div>
          </Grid>
        </Grid>
      </div>

      <article className="questionnaire-page-container">
        {/* <header history={history} className="hide-mobile1">
          <div className="questionnaire-status">
            <span>
              <PercentageCircle
                color={overallProgress === 100 ? greenColor : goldColor}
                percent={overallProgress}
                radius={35}
                borderWidth={5}>
                <div className="circle-inner-text">
                  <div className={'percentage circle-font-size'}>{overallProgress}%</div>
                  <span className="text">{intl.get('questionnaire.overall')}</span>
                </div>
              </PercentageCircle>
            </span>
          </div>
        </header> */}

        {/* <div>
        {
            showUserGuide === true ?
            <UserGuide open={showUserGuide}/>: 
            null
        }    
        </div> */}

        {
          <div className="content-parser-container mobile-border-none">
            <ContentParser
              key={pageData.pageId}
              pageId={pageData.pageId}
              data={pageData}
              onChange={setFormValues}
              showLabels={false}
              numberOfColumns={isMobile ? 1 : pageData.numberOfColumns || 3}
              debug={false}
              hasError={isShowingErrors}
              actions={{
                saveQuestionnaire: (cb, isFormComplete, hardReload = reloadPage) => saveQuestionnaireFn(false, false, hardReload, cb, true, isFormComplete),
                forceDisableSubmitBtn: isDisabled => forceDisableSubmitBtnFn(isDisabled),
              }}
              reloadPage={reloadPage}
              toggleReloadPage={toggleReloadPage}
              parentReadOnly={false}
              allowedSpecialChars={allowedSpecialChars}
              allowedValidationMessageSpecialChars= {allowedValidationMessageSpecialChars}
              additionalCharRestict= {additionalCharRestict}
            />
          </div>
        }
      </article>

      <ActionsBarContainer
        progressTitle={menuName}
        isMenuClicked={isMenuClicked}
        formValues={formValues}
        percentProgress={sectionProgressPercent}
        isPageVariant={true}
        routeParams={match.params}
        location={location}
        setSaveHandler={setSaveHandler}
        setShowErrors={setShowErrors}
        getSaveFn={fn => (saveQuestionnaireFn = fn)}
        resetMenuButtonClicked={resetMenuButtonClicked}
        getforceDisableSubmitBtnFn={fn => (forceDisableSubmitBtnFn = fn)}
        reloadPage={reloadPage}
        toggleReloadPage={toggleReloadPage}
        onSubmitComplete={() => redirectPage()}
      />
    </div>
  );
};

export default QuestionnairePagePres;
